<mat-table [dataSource]="dataSource()">
  <ng-container matColumnDef="services">
    <mat-header-cell *matHeaderCellDef>{{ 'UI.GENERAL.SERVICES' | transloco }}</mat-header-cell>

    <mat-cell *matCellDef="let element">
      <div class="font-semibold">
        {{ 'UI.GENERAL.APPS_SERVICES.' + element | transloco }}
      </div>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="action">
    <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>

    <mat-cell *matCellDef="let element">
      <mat-slide-toggle (change)="onChangeAppStatus($event, element)" [checked]="appServicesConfig()[element]">
        {{ (appServicesConfig()[element] ? 'UI.GENERAL.ACTIVE' : 'UI.GENERAL.INACTIVE') | transloco }}
      </mat-slide-toggle>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
